<template>
  <div></div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import SolutionsModal from "../components/SolutionsModal";

export default {
  name: "CategoryMixin",
  computed: {
    ...mapGetters(["currentSubCategory"]),

  },
  methods: {
    isOrderColumnPresent(list){
      var filteredList = list.filter(item=> item.ehOrder)
      return filteredList  && filteredList.length>0;
    },
    ...mapMutations(["setAllCategories"]),
    sortCategories(categories){
      if(this.isOrderColumnPresent(categories)){
        return categories
                .slice()
                .sort((a, b) => a.ehOrder && a.ehOrder - b.ehOrder);
      }else{
        return categories
                .slice()
                .sort((a, b) => a.name.localeCompare(b.name));
      }
    },
    processAppDataResponse(appData) {

      if (appData && appData.categories) {

        let allCategories = [];
        appData.categories.forEach(category => {
          allCategories.push(category);

          allCategories = this.constructArray(category, allCategories);
        });
        this.setAllCategories(allCategories);
      }
    },
    constructArray(category, allCategories) {

      if (category.childCategories && category.childCategories.length > 0) {
        category.childCategories.forEach(childCategory => {
          childCategory.parentCategoryId = category.id;
          allCategories.push(childCategory);
          allCategories = this.constructArray(childCategory, allCategories);
        });
      }
      allCategories.push(...this.retreiveSolutions(category));

      return allCategories;
    },
    retreiveSolutions(category){
      let targets = [];
      if(category.solutions && category.solutions.length>0){
        category.solutions.forEach(solution=>{
          solution.targets.forEach(target=>{
            target.solutionName = target.name
            target.name = target.linkName
            targets.push(target)
          })

        })
      }else if(category.childCategories){
        category.childCategories.forEach(childCategory=>{
          if(childCategory.solutions && childCategory.solutions.length>0) {
            childCategory.solutions.forEach(solution => {
              solution.targets.forEach(target => {
                target.solutionName = target.name
                target.name = target.linkName
                targets.push(target)
              })
            })
          }
        });
      }
      return targets;
    },
    isDisplayWithParentTypeSolution(category){
      if(category.childCategories &&
      category.childCategories[0].solutions && category.childCategories[0].solutions.length>0 &&
      category.childCategories[0].solutions[0].pageType && category.childCategories[0].solutions[0].pageType === "DISPLAY_WITH_PARENT"){
        return true;
      }
      return false;
    },
    openSolutionsModal(subCategory) {
      this.$modal.show(
        SolutionsModal,
        { subCategory: subCategory },
        {
          adaptive: true,
          maxWidth: 800,
          height: subCategory.solutions[0].targets.length > 2 ? "700" : "420",
          classes: [subCategory.solutions[0].targets.length > 2 ? "tall-modal":"app-modal"],
          width: "100%",
        },
        {
          "before-close": this.beforeClose
        }
      );
    },
    beforeClose(event) {
      this.$route.params.id === this.currentSubCategory.id
        ? history.back()
        : history.pushState(
            {},
            null,
            "/apps/new-guides/" +
              this.$route.params.alias +
              "/" +
              this.currentSubCategory.id
          );
    }
  }
};
</script>

<style scoped>
</style>